var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	85: () => (loadStrictSingletonVersion("default", "@angular/core", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	47615: () => (loadStrictSingletonVersion("default", "@angular/common", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	47731: () => (loadStrictSingletonVersion("default", "@angular/router", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	41862: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	26109: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [4,7,8,2], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	70309: () => (loadStrictSingletonVersion("default", "rxjs", false, [4,7,8,2], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	72345: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	4023: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_di_mjs-_84d20").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))))),
	11315: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs-_22bb1").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	93880: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	34890: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_private_mjs-_688b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))))),
	3176: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_layout_mjs-_77ce1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))))),
	38928: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	53848: () => (loadStrictSingletonVersion("default", "@angular/cdk/dialog", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_dialog_mjs-_76f31").then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))))),
	52676: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_overlay_mjs-_40551").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	67868: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_portal_mjs-_b9701").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	51672: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_coercion_mjs-_bff61").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	81376: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	88414: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b01").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))))),
	13344: () => (loadStrictSingletonVersion("default", "@angular/cdk/accordion", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_accordion_mjs-_46101").then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))))),
	19314: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_collections_mjs-_c5cc1").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))))),
	72788: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_platform_mjs-_90951").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	11786: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_private_mjs-_ae971").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))))),
	35698: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_mjs-_b1b11").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	44238: () => (loadStrictSingletonVersion("default", "@angular/cdk/stepper", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_stepper_mjs-_3f481").then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))))),
	81811: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	87820: () => (loadStrictSingletonVersion("default", "@angular/cdk/table", false, [4,20,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_table_mjs-_257c1").then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 90198))))))),
	75979: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_2a591").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	77876: () => (loadStrictSingletonVersion("default", "@jsverse/transloco", false, [4,7,6,1], () => (__webpack_require__.e("node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs-_970b1").then(() => (() => (__webpack_require__(/*! @jsverse/transloco */ 88065))))))),
	1965: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [4,20,3,27], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1").then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	44608: () => (loadStrictSingletonVersion("default", "@ngrx/store", false, [4,20,1,0], () => (__webpack_require__.e("node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da111").then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))))),
	91474: () => (loadStrictSingletonVersion("default", "ladda", false, [4,2,0,3], () => (__webpack_require__.e("node_modules_ladda_js_ladda_js").then(() => (() => (__webpack_require__(/*! ladda */ 38272))))))),
	19522: () => (loadStrictSingletonVersion("default", "chart.js", false, [4,3,9,1], () => (__webpack_require__.e("node_modules_chart_js_dist_chart_mjs").then(() => (() => (__webpack_require__(/*! chart.js */ 57291)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular-architects_module-federation-tools_fesm2022_angular-architects-module-fe-6501301": [
		85,
		47615,
		47731,
		41862
	],
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a590": [
		85
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a81": [
		85
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca010": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_accordion_mjs-_46100": [
		85,
		70309
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d90": [
		85
	],
	"node_modules_angular_cdk_fesm2022_coercion_mjs-_bff60": [
		85
	],
	"node_modules_angular_cdk_fesm2022_collections_mjs-_c5cc0": [
		85,
		70309
	],
	"node_modules_angular_cdk_fesm2022_dialog_mjs-_76f30": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_layout_mjs-_77ce0": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_observers_private_mjs-_ae970": [
		85,
		26109,
		70309
	],
	"node_modules_angular_cdk_fesm2022_observers_mjs-_b1b10": [
		85,
		26109,
		70309
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40550": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90950": [
		85,
		47615
	],
	"node_modules_angular_cdk_fesm2022_portal_mjs-_b9700": [
		85
	],
	"node_modules_angular_cdk_fesm2022_private_mjs-_688b0": [
		85
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b00": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_stepper_mjs-_3f480": [
		85,
		26109,
		70309,
		72345
	],
	"node_modules_angular_cdk_fesm2022_table_mjs-_257c0": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		85,
		26109,
		70309
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		85,
		70309
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f0": [
		4023,
		11315,
		26109,
		70309
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		70309,
		11315,
		4023,
		26109
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		85,
		26109,
		47615,
		70309
	],
	"node_modules_angular_material_fesm2022_badge_mjs-_64461": [
		93880,
		85,
		34890,
		3176,
		38928
	],
	"node_modules_angular_material_fesm2022_dialog_mjs-_b8751": [
		53848,
		52676,
		67868,
		85,
		51672,
		3176,
		70309,
		26109,
		81376,
		93880,
		88414,
		38928
	],
	"node_modules_angular_material_fesm2022_expansion_mjs-_0cfc1": [
		85,
		13344,
		67868,
		93880,
		26109,
		81376,
		70309,
		19314,
		3176,
		34890,
		38928
	],
	"node_modules_angular_material_fesm2022_progress-spinner_mjs-_15ea1": [
		85,
		47615,
		3176,
		93880,
		38928
	],
	"node_modules_angular_material_fesm2022_select_mjs-_b9181": [
		93880,
		81376,
		85,
		70309,
		72788,
		51672,
		34890,
		3176,
		38928,
		47615,
		26109,
		11786,
		52676,
		88414,
		19314,
		72345,
		35698
	],
	"node_modules_angular_material_fesm2022_sidenav_mjs-_ad751": [
		93880,
		38928,
		51672,
		81376,
		72788,
		88414,
		85,
		70309,
		26109,
		3176
	],
	"node_modules_angular_material_fesm2022_sort_mjs-_9a191": [
		85,
		93880,
		81376,
		70309,
		34890,
		3176,
		38928
	],
	"node_modules_angular_material_fesm2022_stepper_mjs-_627a1": [
		67868,
		44238,
		85,
		93880,
		70309,
		47615,
		34890,
		26109,
		81811,
		41862,
		38928,
		72788,
		51672,
		3176
	],
	"node_modules_angular_material_fesm2022_table_mjs-_9ed61": [
		85,
		87820,
		19314,
		93880,
		38928,
		70309,
		51672,
		26109
	],
	"node_modules_angular_material_fesm2022_tooltip_mjs-_e18c1": [
		26109,
		51672,
		81376,
		85,
		47615,
		72788,
		93880,
		38928,
		52676,
		67868,
		70309,
		3176,
		88414
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a1": [
		85,
		75979,
		47615
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		85,
		47615,
		81811
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		85,
		26109,
		41862,
		47615,
		70309
	],
	"node_modules_jsverse_transloco-locale_fesm2022_jsverse-transloco-locale_mjs-_f7fc1": [
		85,
		77876,
		70309,
		26109
	],
	"node_modules_jsverse_transloco-messageformat_fesm2022_jsverse-transloco-messageformat_mjs-_3d8b1": [
		85,
		77876
	],
	"node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs-_970b0": [
		85,
		1965,
		70309
	],
	"node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs-_56481": [
		70309,
		26109,
		85,
		44608
	],
	"node_modules_ngrx_operators_fesm2022_ngrx-operators_mjs-_42c11": [
		70309,
		26109
	],
	"node_modules_ngrx_router-store_fesm2022_ngrx-router-store_mjs-_777d1": [
		44608,
		85,
		47731,
		26109
	],
	"node_modules_ngrx_store-devtools_fesm2022_ngrx-store-devtools_mjs-_f60c1": [
		85,
		44608,
		70309,
		26109,
		1965
	],
	"node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da110": [
		85,
		1965,
		26109,
		70309
	],
	"node_modules_sentry_angular_fesm2020_sentry-angular_mjs-_51461": [
		85,
		81811,
		47731,
		70309,
		26109
	],
	"node_modules_swimlane_ngx-datatable_fesm2020_swimlane-ngx-datatable_mjs-_1ffc1": [
		85,
		47615,
		70309,
		26109
	],
	"node_modules_angular2-ladda_fesm2020_angular2-ladda_mjs-_70c71": [
		85,
		47615,
		91474
	],
	"node_modules_ng2-charts_fesm2020_ng2-charts_mjs-_204d1": [
		85,
		19522,
		26109,
		70309
	],
	"node_modules_ngx-device-detector_fesm2022_ngx-device-detector_mjs-_1c591": [
		85,
		47615
	],
	"node_modules_ngx-panzoom_fesm2022_ngx-panzoom_mjs-_d5d01": [
		85
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		81811
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4621": [
		70309
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		26109,
		41862,
		47615,
		70309
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		47615
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011": [
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_layout_mjs-_77ce1": [
		26109,
		47615,
		70309
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b01": [
		47615
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40551": [
		47615
	],
	"node_modules_angular_cdk_fesm2022_dialog_mjs-_76f31": [
		47615
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90951": [
		47615
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		26109,
		70309
	],
	"node_modules_angular_cdk_fesm2022_stepper_mjs-_3f481": [
		72345
	],
	"node_modules_angular_cdk_fesm2022_table_mjs-_257c1": [
		47615
	],
	"node_modules_jsverse_transloco_fesm2022_jsverse-transloco_mjs-_970b1": [
		1965,
		70309
	],
	"node_modules_angular_core_fesm2022_rxjs-interop_mjs-_b06f1": [
		4023,
		11315,
		26109
	],
	"node_modules_ngrx_store_fesm2022_ngrx-store_mjs-_da111": [
		1965,
		70309
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}